import cn from 'classnames';
import SmallCaps from 'components/typography/small-caps';
import { useConfig } from 'config/use-config';
import { Carrier } from 'constants/carrier';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import IconDhl from '../../../../assets/icons/dhl.svg';
import IconDiePost from '../../../../assets/icons/die-post.svg';
import IconDpd from '../../../../assets/icons/dpd.svg';

const CarrierLogo: React.FC<{ carrier: Carrier }> = ({ carrier }) => {
  switch (carrier) {
    case Carrier.DPD:
      return <IconDpd className="h-8 w-auto" data-test="carrier-logo-dpd" />;
    case Carrier.DHL:
      return (
        <div
          className="flex h-12 w-20 items-center justify-center bg-[#FECC00]"
          data-test="carrier-logo-dhl"
        >
          <IconDhl className="h-auto w-20" />
        </div>
      );
    case Carrier.DHL_GO_GREEN:
      return (
        <img
          src="/images/dhl-gogreen-plus.png"
          alt="DHL GoGreen Plus"
          className="h-12 w-auto"
          data-test="carrier-logo-dhl-gogreen"
        />
      );
    case Carrier.DIE_POST:
      return <IconDiePost className="h-5 w-auto lg:h-6" data-test="carrier-logo-die-post" />;
    default:
      return null;
  }
};

interface DeliveryLogosProps {
  className?: string | undefined;
}

const DeliveryLogos: React.FC<DeliveryLogosProps> = ({ className }) => {
  const { carriers } = useConfig();

  return (
    <div
      className={cn(
        'flex flex-col justify-center px-4 pt-6 text-center md:justify-start md:pt-0 md:text-left lg:px-8',
        className
      )}
    >
      <SmallCaps>
        <div className="text-primary-main whitespace-nowrap">
          <FormattedMessage id="footer:title-shipping" />
        </div>
      </SmallCaps>
      <div
        className="flex items-center justify-center gap-3 pt-2 md:justify-start"
        data-test="delivery-logos"
      >
        {carriers?.map((carrier) => (
          <CarrierLogo key={carrier} carrier={carrier} />
        ))}
      </div>
    </div>
  );
};

export default DeliveryLogos;
